/* eslint-disable @typescript-eslint/no-var-requires */
const env = require('./config.js');

const base64 = require('./base64.js');
require('./hmac.js');
require('./sha1.js');
const Crypto = require('./crypto.js');
import axios from 'axios';
import { host } from '@/utils/config';

/*
 *上传文件到阿里云oss
 *@param - filePath :图片的本地资源路径
  @param - path :上传oss哪个路径下
 *@param - successc:成功回调
 *@param - failc:失败回调
 */
const uploadFile = function(filePath, path, data, token, successc, failc) {
	//存放图片命名格式：自定义时间戳给图片名字(可以自己改)
	// const aliyunFileKey = path + new Date().getTime() + Math.floor(Math.random() * 150) + '.' + suffix;

	// const aliyunServerURL = env.uploadImageUrl; //OSS地址，https
	// const accessid = token.OSSAccessKeyId;
	// const policyBase64 = getPolicyBase64();
	// const signature = getSignature(policyBase64, token.AccessKeySecret);
	// const securityToken = token.SecurityToken;

	let formData = new FormData();
	// formData.append('key', aliyunFileKey);
	// formData.append('policy', policyBase64);
	// formData.append('OSSAccessKeyId', accessid);
	// formData.append('signature', signature);
	// formData.append('success_action_status', '200');
	// formData.append('x-oss-security-token', securityToken);
	formData.append('file', filePath);

	if (data){
		for (let item in data){
			formData.append(item, data[item]);
		}
	}
	// axios.post(aliyunServerURL, formData, {
	// 	'Content-Type': 'multipart/form-data'
	// }).then(res => {
	// 	if (res.status !== 200) {
	// 		failc(new Error('上传错误:' + JSON.stringify(res)))
	// 		return;
	// 	}
	// 	successc(aliyunServerURL + aliyunFileKey);
	// }).catch(err => {
	// 	console.log('上传失败');
	// })
	
	let url = host + '/api/image/upload?PlatForm=routuan&Path=image';
	if (path == 'File'){
		url = host + '/api/file/upload?PlatForm=routuan&Path=File';
	}

	axios.post(url, formData).then(res => {
		if (res.status !== 200) {
			failc(new Error('上传错误:' + JSON.stringify(res)))
			return;
		}
		
		if (res.data.IsSuccess){
			successc(res.data.Result[0]);
		}else{
			failc(new Error('上传错误:' + JSON.stringify(res)))
		}
		
	}).catch(err => {
		console.log('上传失败');
	})
	
}

const getPolicyBase64 = function() {
	let date = new Date();
	date.setHours(date.getHours() + env.timeout);
	let srcT = date.toISOString();
	const policyText = {
		"expiration": srcT, //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了 
		"conditions": [
			["content-length-range", 0, 5 * 1024 * 1024] // 设置上传文件的大小限制,5mb
		]
	};

	const policyBase64 = base64.encode(JSON.stringify(policyText));
	return policyBase64;
}

const getSignature = function(policyBase64, AccessKeySecret) {
	const accesskey = AccessKeySecret;
	const bytes = Crypto.HMAC(Crypto.SHA1, policyBase64, accesskey, {
		asBytes: true
	});
	const signature = Crypto.util.bytesToBase64(bytes);
	return signature;
}

export default uploadFile;
